/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import dataService from "service/dataService";
import logo from "../../../../assets/img/logo/apex.png";
import { PDFDownloadLink } from '@react-pdf/renderer'; 
import InvoicePdf from "./InvoicePdf";


interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  data?: any; // Optional prop for passing data
}

interface TimecardEntry {
  creationDate:Date |null;
  studentId: string;
  fullName: string;
  firstName:string;
  lastName:string;
  grade:string;
  major: string;
  date: Date;
  hours: number;
  hourlyRate: number;
  email:string;
  id:string;
  discount:number;
}

interface InvoiceItem {
  studentName: string;
  major: string;
  totalHours: number;
  ratePerHour: number;
  subtotal: number;
  discount:number;
 // date:Date;
}
// eslint-disable-next-line react-hooks/rules-of-hooks
//const [invoices, setInvoices] = useState<InvoiceItem[]>([]);

const InvoiceGenerator: React.FC<ModalProps> = ({ isOpen, onClose, title, children, data }) => {
const [invoices, setInvoices] = useState<InvoiceItem[]>([]);
const [timecard, setTimeCard] = useState<TimecardEntry[]>([]);
const [discount, setDiscount] = useState<number[]>([]);
console.log('InvoiceGenerator received data prop:', data );
  // Helper to process timecard data into invoice items
  const processTimecardData = (data: TimecardEntry[]) => {
    const groupedByStudentAndMajor: Record<string, InvoiceItem> = {};
    console.log('Processing timecard data:', data); 
     data.map((entry, index) => {
      console.log("data"+data[index].discount)
   
      const key = `${entry.studentId}-${entry.major}`;
   //   setDiscount(Math.max(entry.discount));
      if (!groupedByStudentAndMajor[key]) {
        groupedByStudentAndMajor[key] = {
          studentName: entry.fullName,
          major: entry.major,
          totalHours: 0,
          ratePerHour: entry.hourlyRate,
          subtotal: 0,
          discount: Number(entry.discount)
         // date:entry.date
         };
      }

      setDiscount((prevArray) => [...prevArray, (groupedByStudentAndMajor[key].discount)]);
  // setDiscount([(groupedByStudentAndMajor[key].discount)]);
      console.log("Discount:::"+discount);
        // setDiscount(groupedByStudentAndMajor[key].discount);

const totalHours = data.reduce((sum, entry) => sum + entry.hours, 0);
console.log(totalHours+":"+discount.length);
      groupedByStudentAndMajor[key].totalHours += entry.hours;
      groupedByStudentAndMajor[key].subtotal = groupedByStudentAndMajor[key].totalHours * groupedByStudentAndMajor[key].ratePerHour; 

    });

    console.log("Math.max"+Math.max(...discount));

    console.log('Processed invoice data:', Object.values(groupedByStudentAndMajor) +"timecard"+Object.values(timecard));
    return Object.values(groupedByStudentAndMajor);
  };

  useEffect(() => {
    if ( data && isOpen ) {
      console.log('InvoiceGenerator opened with data:', data);
      dataService.getDailyHoursData(data.name, data.month, data.year).then((hoursData) => {
      console.log('Fetched daily hours data in InvoiceGenerator:', hoursData);
      const invoiceData = processTimecardData(hoursData);
      setTimeCard(hoursData);
      setInvoices(invoiceData);
      }).catch((error) => {
        console.error('Error fetching daily hours data in InvoiceGenerator:', error);
      });
        
    } else if (!isOpen) {
       setDiscount([0]);
      setInvoices([]);
    }
  }, [data, isOpen]);

   const getHighestValue = (): number | undefined => {
    if (discount.length === 0) {
      return undefined; // Or throw an error, or return a default value
    }
    return Math.max(...discount);
  };

/*   if (loading) {
    return <Progress value={0} color="blue" width="45%" />;
  } */

  if (!isOpen) { return null; }
  const highestValue = getHighestValue();
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50"
    >



      <div className="bg-white p-6 rounded-lg shadow-lg relative p-4 w-full max-w-2xl max-h-full">
        <div className="flex justify-between items-center mb-4 relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
          <h2 className="text-xl font-semibold text-indigo-600">Invoice Details For {children}</h2>
          <hr className="my-2" />
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            &times;
          </button>
        </div>
          <div className="mb-4 text-gray-700">
            {data && (
            <div className="mt-4 p-2  rounded border border-gray-400">
            <div className="grid gap-4">
            <div>
                 <img className="h-auto max-w-lg mx-auto max-w-full rounded-lg items-center" src={logo} alt="Apex Logo"/>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
               <h3 className="font-medium font-semibold">Student Name: <span className=" text-gray-600"> {data.name} </span> </h3> 
              </div>
              <div>
               <h3 className="font-medium font-semibold">Invoice Created Date: <span className="text-gray-600">{new Date().toLocaleDateString()}</span></h3> 
              </div>
              <div>
               <h3 className="font-medium font-semibold">Invoice For: <span className="text-gray-600"> {data.month}/{data.year}</span> </h3> 
              </div>
              <div>
               <h3 className="font-medium font-semibold">Invoice #: <span className=" text-gray-600">Apex :0{data.index + 1 } </span></h3> 
              </div>
              
            </div>
          </div>
                      
                {invoices.length > 0 ? (
                  <table className="w-full mt-5 text-sm text-left rtl:text-right text-gray-700 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"> 
                        <tr>
                            <th className="border border-gray-300 px-2 py-1">Major</th>
                            <th className="border border-gray-300 px-2 py-1">Total Hours</th>
                            <th className="border border-gray-300 px-2 py-1">Rate Per Hour</th>     
                            <th className="border border-gray-300 px-2 py-1">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {invoices.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600">    
                                <td className="border border-gray-500 px-2 py-1">{item.major}</td>
                                <td className="border border-gray-500 px-2 py-1">{item.totalHours}</td> 
                                <td className="border border-gray-500 px-2 py-1">${item.ratePerHour}</td>
                                <td className="border border-gray-500 px-2 py-1">${item.subtotal}</td>
                            </tr>   
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="mt-4 text-gray-600">No invoice data available.</p>
                )}
               <span className="mt-4 block font-medium text-lg text-indigo-600 text-right">     
                    Total Amount: ${invoices.reduce((sum, item) => sum + item.subtotal, 0).toFixed(2)}
                </span>
                
                { (highestValue > 0) ?      
                <span className="mt-4 block font-medium text-md text-red-600 text-right">     
                    Discount Applied: {highestValue} %
                </span>:''}
                { (highestValue > 0) ?
                   <span className="mt-4 block font-medium text-lg text-blue-800 text-right">     
                   <hr></hr>
                    Final Amount: ${(invoices.reduce((sum, item) => sum + item.subtotal, 0) - (invoices.reduce((sum, item) => sum + item.subtotal, 0) * highestValue/100)).toFixed(2)}
                </span>
                :''
                }  
                <div className="flex items-center justify-end p-2 border-t border-solid rounded-b mt-4">
                  {/* <button data-modal-hide="default-modal" type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Download</button> */}
                          <PDFDownloadLink document={<InvoicePdf data={invoices } invoiceFor={data.month +'/'+ data.year} incoiceNo={data.index + 1 } total={invoices.reduce((sum, item) => sum + item.subtotal, 0)} timecard={timecard} 
                           discount={highestValue} 
                           finalAmount={(invoices.reduce((sum, item) => sum + item.subtotal, 0) - (invoices.reduce((sum, item) => sum + item.subtotal, 0) * highestValue/100)).toFixed(2)}
                          />} fileName={`invoice-${data.name}.pdf`}>
            
                  <button  data-modal-hide="default-modal" type="button"  disabled={invoices.length === 0}
                   className={`px-4 py-2 rounded-md transition-all duration-200 
                    ${invoices.length === 0 
                      ? 'bg-blue-300 cursor-not-allowed text-white' 
                      : 'bg-blue-800 hover:bg-blue-600 text-white'
                    }`}>
                    Download
                
                  </button>
              
                </PDFDownloadLink> 
                  <button data-modal-hide="default-modal" onClick={onClose} type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Close</button>
                  {/* Add other buttons if needed */}
                </div>

              </div>

             
            )}
          </div>
        </div>
      </div>

  );
};

export default InvoiceGenerator;